export enum CampaignModeEnum {
    rolling,
    snapshot
}
